(() => {
  const isPreview = ['localhost', '127.0.0.1'].includes(window.location.hostname);
  const pendingEvents = [];
  let publishAttempts = 0;

  const sendToShopify = (name, data) => {
    if (!window.Shopify?.analytics?.publish) return false;
    window.Shopify.analytics.publish(name, data);
    return true;
  };

  const flushPendingEvents = () => {
    publishAttempts += 1;
    if (!window.Shopify?.analytics?.publish) {
      if (publishAttempts < 40) window.setTimeout(flushPendingEvents, 250);
      return;
    }

    pendingEvents.splice(0).forEach(({ name, data }) => sendToShopify(name, data));
  };

  const getEventData = (element) => {
    const data = {};

    Array.from(element.attributes).forEach((attribute) => {
      const prefix = 'data-drg-event-';
      if (!attribute.name.startsWith(prefix)) return;

      const key = attribute.name.slice(prefix.length).replaceAll('-', '_');
      let value = attribute.value;
      if (value === 'true') value = true;
      if (value === 'false') value = false;
      data[key] = value;
    });

    return {
      ...data,
      page_path: window.location.pathname,
    };
  };

  const publish = (name, data = {}) => {
    if (!name) return;

    const payload = {
      ...data,
      page_path: data.page_path || window.location.pathname,
    };

    if (!isPreview && !sendToShopify(name, payload)) {
      pendingEvents.push({ name, data: payload });
      if (publishAttempts === 0) {
        publishAttempts = 1;
        window.setTimeout(flushPendingEvents, 250);
      }
    }

    document.dispatchEvent(new CustomEvent('dragiyn:analytics', {
      detail: { name, data: payload },
    }));

    if (isPreview) console.info(`[Dragiyn analytics] ${name}`, payload);
  };

  document.addEventListener('click', (event) => {
    const trackedElement = event.target.closest('[data-drg-event]');
    if (!trackedElement) return;

    publish(trackedElement.dataset.drgEvent, getEventData(trackedElement));
  });

  const impressions = document.querySelectorAll('[data-drg-impression]');
  if (!impressions.length) return;

  if (!('IntersectionObserver' in window)) {
    impressions.forEach((element) => publish(element.dataset.drgImpression, getEventData(element)));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      publish(entry.target.dataset.drgImpression, getEventData(entry.target));
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.35 });

  impressions.forEach((element) => observer.observe(element));
})();
